import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import EdutainmentPage from './pages/EdutainmentPage';
import PocEmblemPage from './pages/PocEmblemPage';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="min-h-screen bg-ink text-vellum flex flex-col">
      <ScrollToTop />
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/edutainment" element={<EdutainmentPage />} />
          <Route path="/games" element={<Navigate to="/edutainment" replace />} />
          <Route path="/_poc/emblem" element={<PocEmblemPage />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
